var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortexElectricity01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#09B2C9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M251.85,74.4,162.32,238l53.93-3.74L192.33,341.75l89.53-163.66-53.93,3.74ZM222.11,96.47a111.6,111.6,0,0,0-32.83,218.26l3.46-15.56A95.68,95.68,0,0,1,221,112.42l8.51-15.58c-2.46-.15-4.91-.37-7.41-.37Zm32.79,4.92L251.43,117a95.7,95.7,0,0,1-28.26,186.8l-8.52,15.56c2.48.15,4.94.37,7.46.37A111.61,111.61,0,0,0,254.9,101.39Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortexElectricity01);
export default __webpack_public_path__ + "static/media/Vortex_electricity-01.7cd38ce15b400a9ae3b9d601a756b10b.svg";
export { ForwardRef as ReactComponent };